import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'
import { connect } from 'react-redux'
import Grid from '@material-ui/core/Grid'
import InputBase from '@material-ui/core/InputBase'

import Wrapper from '../../components/Wrapper'
import Header from '../../components/Header'
import Body from '../../components/Body'
import Footer from '../../components/Footer'
import TopBar from '../../components/TopBar'
import SubmitButton from '../../components/SubmitButton'

import Typography from '@material-ui/core/Typography'
import Modal from '@material-ui/core/Modal'
import ErrorBuy from '../../assets/motor/error_buy.png'
import Icon from '@material-ui/core/Icon'
import IconButton from '@material-ui/core/IconButton'

import _ from 'lodash'
import { motorService } from '../../services/motor.service'
import Loading from '../../components/Loading'

const fontDefault = {
  fontFamily: 'thonburiregular',
  fontStyle: 'normal',
}

const styles = {
  textTopBar: {
    ...fontDefault,
    color: '#333333',
    fontSize: '18px',
    fontWeight: 'bold',
  },
  titleContainer: {
    textAlign: 'center',
  },
  titleVerify: {
    ...fontDefault,
    color: '#0e162c',
    fontSize: '16px',
  },
  digitField: {
    borderBottom: '2px solid #c3c5cb',
    paddingTop: '3px',
    paddingBottom: '3px',
    color: '#0e162c',
    ...fontDefault,
    fontFamily: 'San Francisco Text',
    fontSize: '18px',
  },
  digitFieldActive: {
    borderBottom: '2px solid #1a63b6',
    paddingTop: '3px',
    paddingBottom: '3px',
    color: '#0e162c',
    ...fontDefault,
    fontFamily: 'San Francisco Text',
    fontSize: '18px',
  },
  noReceive: {
    textAlign: 'center',
    ...fontDefault,
    fontWeight: 'bold',
    color: '#878B96',
  },
  resend: {
    marginTop: '16px',
    fontWeight: 'bold',
    border: 'unset',
    backgroundColor: 'unset',
    color: '#118df5',
    fontSize: '14px',
    padding: '3px',
    paddingLeft: '10px',
    paddingRight: '10px',
    ...fontDefault,
  },
  refCode: {
    ...fontDefault,
    fontSize: '12px',
    color: '#878b96',
  },
  error: {
    ...fontDefault,
    color: '#ff4d4f',
    fontSize: '12px',
  },
  modalContainer: {
    outline: 0,
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    position: 'absolute',
    width: '90%',
    maxHeight: '80%',
    backgroundColor: 'white',
    borderRadius: '8px',
  },
  modalContent: {
    overflowY: 'auto',
    padding: '15px',
  },
  modalClose: {
    position: 'absolute',
    right: '0px',
    top: '0px',
  },
}

class VerifyOTP extends Component {
  state = {
    firstInput: '',
    secondInput: '',
    thirdInput: '',
    fourthInput: '',
    fifthInput: '',
    sixthInput: '',
    isTruePaymentError: false,
    isError: false,
    isLoading: false,
  }

  goToNextPage = async () => {
    const {
      history: { push },
      setUserInput,
      auth,
      userInput,
      orderId,
      currentProduct,
      currentPackage,
      // birthData,
      address,
      effData,
    } = this.props
    const {
      firstInput,
      secondInput,
      thirdInput,
      fourthInput,
      fifthInput,
      sixthInput,
    } = this.state
    const token = _.get(auth, 'token', null)

    const splittedFullname = _.get(userInput, 'fullname', '').split(/ +/)
    const first_name = splittedFullname.shift() || ''
    const last_name = splittedFullname.join(' ')
    const birthData = new Date(
      _.get(userInput, 'birthdate', '0000-01-01') + 'T07:00:00'
    )

    try {
      this.setState({
        isLoading: true,
      })
      let response
      if (currentProduct === 'V') {
        response = await motorService.postPaymentVMI(token, orderId, {
          package_id: parseInt(_.get(currentPackage, 'ID', 0)),
          id_card: _.get(userInput, 'ID', ''),
          title: _.get(userInput, 'gender', ''),
          first_name,
          last_name,
          birth_day: birthData,
          phone_number: _.get(userInput, 'phoneNumber', ''),
          address,
          sub_district: _.get(userInput, 'moreAddress.subdistrict.name', ''),
          sub_district_code: _.get(
            userInput,
            'moreAddress.subdistrict.tumbon_code',
            ''
          ),
          district: _.get(userInput, 'moreAddress.district.name', ''),
          district_code: _.get(userInput, 'moreAddress.district.amph_code', ''),
          province: _.get(userInput, 'moreAddress.province.jw_name', ''),
          province_code: _.get(userInput, 'moreAddress.province.jw_code', ''),
          post_code: _.get(userInput, 'moreAddress.subdistrict.zipcode', ''),
          email: _.get(userInput, 'email', ''),
          coverage_from: effData,
          license_number: _.get(userInput, 'licensePlate', ''),
          plate_province: _.get(userInput, 'plateProvince.abbrv', ''),
          mobile_number: _.get(auth, 'mobile', ''),
          otp_ref: _.get(userInput, 'OTPRef', ''),
          otp_code:
            firstInput +
            secondInput +
            thirdInput +
            fourthInput +
            fifthInput +
            sixthInput,
        })
      } else {
        response = await motorService.postPaymentCMI(token, orderId, {
          id_card: _.get(userInput, 'ID', ''),
          title: _.get(userInput, 'gender', ''),
          first_name,
          last_name,
          birth_day: birthData,
          phone_number: _.get(userInput, 'phoneNumber', ''),
          address,
          sub_district: _.get(userInput, 'moreAddress.subdistrict.name', ''),
          sub_district_code: _.get(
            userInput,
            'moreAddress.subdistrict.tumbon_code',
            ''
          ),
          district: _.get(userInput, 'moreAddress.district.name', ''),
          district_code: _.get(userInput, 'moreAddress.district.amph_code', ''),
          province: _.get(userInput, 'moreAddress.province.jw_name', ''),
          province_code: _.get(userInput, 'moreAddress.province.jw_code', ''),
          post_code: _.get(userInput, 'moreAddress.subdistrict.zipcode', ''),
          email: _.get(userInput, 'email', ''),
          coverage_from: effData,
          license_number: _.get(userInput, 'licensePlate', ''),
          plate_province: _.get(userInput, 'plateProvince.abbrv', ''),
          mobile_number: _.get(auth, 'mobile', ''),
          otp_ref: _.get(userInput, 'OTPRef', ''),
          otp_code:
            firstInput +
            secondInput +
            thirdInput +
            fourthInput +
            fifthInput +
            sixthInput,
        })
      }
      if (_.get(response, 'success', false)) {
        setUserInput({
          orderSuccessData: _.get(response, 'data', {}),
        })
        this.setState({
          isLoading: false,
        })
        push('/payment-success')
      } else {
        const mixpanel = _.get(window, 'mixpanel', undefined)
        const dataLayer = _.get(window, 'dataLayer', undefined)
        switch (_.get(response, 'code', '')) {
          case 0:
            setUserInput({
              orderSuccessData: _.get(response, 'data', {}),
            })
            this.setState({
              isLoading: false,
            })
            push('/payment-success')
            break
          case 1:
            if (!!mixpanel) {
              mixpanel.track('Insurance Car Error', {
                'Error message': 'Insufficient fund',
                'Error code': 'E10701',
              })
            }
            if (!!dataLayer) {
              dataLayer.push({
                event: 'error-page', // Required
                errorMsg: 'Insufficient fund',
              })
            }
            push('/error-payment')
            document.getElementById("rootScreen").scrollTo(0, 0)
            break
          case 2:
            this.setState({
              isLoading: false,
              isTruePaymentError: true,
            })
            break
          case 3:
            if (!!mixpanel) {
              mixpanel.track('Insurance Car Error', {
                'Error message': 'BKI error',
                'Error code': 'E10702',
              })
            }
            if (!!dataLayer) {
              dataLayer.push({
                event: 'error-page', // Required
                errorMsg: 'BKI error',
              })
            }
            push('/error-buy')
            document.getElementById("rootScreen").scrollTo(0, 0)
            break
          case 4:
            this.setState({
              isLoading: false,
              isError: true,
            })
            break
          default:
            if (!!mixpanel) {
              mixpanel.track('Insurance Car Error', {
                'Error message': 'Unknown OTP response code',
                'Error code': 'E10703',
              })
            }
            if (!!dataLayer) {
              dataLayer.push({
                event: 'error-page', // Required
                errorMsg: 'Unknown OTP response code',
              })
            }
            push('/error-system')
            document.getElementById("rootScreen").scrollTo(0, 0)
            break
        }
      }
    } catch (error) {
      const { showError } = this.props
      showError(error.message)
      this.setState({
        isLoading: true,
      })
      if (error.message === 'Network Error') {
        const mixpanel = _.get(window, 'mixpanel', undefined)
        if (!!mixpanel) {
          mixpanel.track('Insurance Car Error', {
            'Error message': error.message,
            'Error code': 'E10705',
          })
        }
        const dataLayer = _.get(window, 'dataLayer', undefined)
        if (!!dataLayer) {
          dataLayer.push({
            event: 'error-page', // Required
            errorMsg: error.message,
          })
        }
        push('/error-network')
        document.getElementById("rootScreen").scrollTo(0, 0)
        return
      }
      const response = _.get(error, 'response', {})
      const responseStatus = response.status
      if (
        responseStatus === 403 ||
        responseStatus === 401 ||
        responseStatus === 400
      ) {
        const mixpanel = _.get(window, 'mixpanel', undefined)
        if (!!mixpanel) {
          mixpanel.track('Insurance Car Error', {
            'Error message': _.get(
              response,
              'message',
              'Verify OTP - Unknown error - ' +
                responseStatus +
                ' ' +
                _.get(error, 'message', '')
            ),
            'Error code': 'E10706',
          })
        }
        const dataLayer = _.get(window, 'dataLayer', undefined)
        if (!!dataLayer) {
          dataLayer.push({
            event: 'error-page', // Required
            errorMsg: _.get(
              response,
              'message',
              'Verify OTP - Unknown error - ' +
                responseStatus +
                ' ' +
                _.get(error, 'message', '')
            ),
          })
        }
        push('/error-system')
        document.getElementById("rootScreen").scrollTo(0, 0)
        return
      }
      if (responseStatus === 500) {
        const mixpanel = _.get(window, 'mixpanel', undefined)
        const dataLayer = _.get(window, 'dataLayer', undefined)
        if (
          error.message === 'true_money_internal_error' ||
          error.message === 'insufficient fund'
        ) {
          if (!!mixpanel) {
            mixpanel.track('Insurance Car Error', {
              'Error message': _.get(
                response,
                'message',
                'Verify OTP - TMN Error - ' +
                  responseStatus +
                  ' ' +
                  _.get(error, 'message', '')
              ),
              'Error code': 'E10710',
            })
          }
          if (!!dataLayer) {
            dataLayer.push({
              event: 'error-page', // Required
              errorMsg: _.get(
                response,
                'message',
                'Verify OTP - TMN Error - ' +
                  responseStatus +
                  ' ' +
                  _.get(error, 'message', '')
              ),
            })
          }
          push('/error-payment')
          document.getElementById("rootScreen").scrollTo(0, 0)
          return
        }
        if (error.message === 'bki_internal_error') {
          if (!!mixpanel) {
            mixpanel.track('Insurance Car Error', {
              'Error message': _.get(
                response,
                'message',
                'Verify OTP - BKI Error - ' +
                  responseStatus +
                  ' ' +
                  _.get(error, 'message', '')
              ),
              'Error code': 'E10710',
            })
          }
          if (!!dataLayer) {
            dataLayer.push({
              event: 'error-page', // Required
              errorMsg: _.get(
                response,
                'message',
                'Verify OTP - BKI Error - ' +
                  responseStatus +
                  ' ' +
                  _.get(error, 'message', '')
              ),
            })
          }
          push('/error-buy')
          document.getElementById("rootScreen").scrollTo(0, 0)
          return
        }
        if (!!mixpanel) {
          mixpanel.track('Insurance Car Error', {
            'Error message': _.get(
              response,
              'message',
              'Verify OTP - Unknown error - ' +
                responseStatus +
                ' ' +
                _.get(error, 'message', '')
            ),
            'Error code': 'E10704',
          })
        }
        if (!!dataLayer) {
          dataLayer.push({
            event: 'error-page', // Required
            errorMsg: _.get(
              response,
              'message',
              'Verify OTP - Unknown error - ' +
                responseStatus +
                ' ' +
                _.get(error, 'message', '')
            ),
          })
        }
        push('/error-system')
        document.getElementById("rootScreen").scrollTo(0, 0)
        return
      }
    }
  }

  backButton = () => {
    const {
      history: { push },
    } = this.props
    push('/payment')
    document.getElementById("rootScreen").scrollTo(0, 0)
  }

  resend = async () => {
    const {
      history: { push },
      setUserInput,
      auth,
    } = this.props
    const token = _.get(auth, 'token', null)
    try {
      this.setState({
        isLoading: true,
      })
      const response = await motorService.getOTP(token)
      if (response.success) {
        setUserInput({
          OTPRef: _.get(response, 'otp_ref', ''),
        })
        this.setState({
          isLoading: false,
          firstInput: '',
          secondInput: '',
          thirdInput: '',
          fourthInput: '',
          fifthInput: '',
          sixthInput: '',
        })
        push('/verify-otp')
      } else {
        if (response.code === 500) {
          const mixpanel = _.get(window, 'mixpanel', undefined)
          if (!!mixpanel) {
            mixpanel.track('Insurance Car Error', {
              'Error message': _.get(
                response,
                'message',
                'Verify OTP - Resend OTP Error - ' + response.code
              ),
              'Error code': 'E10707',
            })
          }
          const dataLayer = _.get(window, 'dataLayer', undefined)
          if (!!dataLayer) {
            dataLayer.push({
              event: 'error-page', // Required
              errorMsg: _.get(
                response,
                'message',
                _.get(
                  response,
                  'message',
                  'Verify OTP - Resend OTP Error - ' + response.code
                )
              ),
            })
          }
          push('/error-system')
          document.getElementById("rootScreen").scrollTo(0, 0)
          return
        }
      }
    } catch (error) {
      const { showError } = this.props
      showError(error.message)
      this.setState({
        isLoading: true,
      })
      if (error.message === 'Network Error') {
        const mixpanel = _.get(window, 'mixpanel', undefined)
        if (!!mixpanel) {
          mixpanel.track('Insurance Car Error', {
            'Error message': error.message,
            'Error code': 'E10708',
          })
        }
        const dataLayer = _.get(window, 'dataLayer', undefined)
        if (!!dataLayer) {
          dataLayer.push({
            event: 'error-page', // Required
            errorMsg: error.message,
          })
        }
        push('/error-network')
        document.getElementById("rootScreen").scrollTo(0, 0)
        return
      }
      const response = _.get(error, 'response', {})
      const responseStatus = response.status
      if (
        responseStatus === 500 ||
        responseStatus === 403 ||
        responseStatus === 401 ||
        responseStatus === 400
      ) {
        const mixpanel = _.get(window, 'mixpanel', undefined)
        if (!!mixpanel) {
          mixpanel.track('Insurance Car Error', {
            'Error message': _.get(
              response,
              'message',
              'Verify OTP - Unknown error - ' +
                responseStatus +
                ' ' +
                _.get(error, 'message', '')
            ),
            'Error code': 'E10709',
          })
        }
        const dataLayer = _.get(window, 'dataLayer', undefined)
        if (!!dataLayer) {
          dataLayer.push({
            event: 'error-page', // Required
            errorMsg: _.get(
              response,
              'message',
              'Verify OTP - Unknown error - ' +
                responseStatus +
                ' ' +
                _.get(error, 'message', '')
            ),
          })
        }
        push('/error-system')
        document.getElementById("rootScreen").scrollTo(0, 0)
        return
      }
    }
  }

  render() {
    const { classes, userInput, auth } = this.props
    const {
      firstInput,
      secondInput,
      thirdInput,
      fourthInput,
      fifthInput,
      sixthInput,
      isTruePaymentError,
      isError,
      isLoading,
    } = this.state
    return (
      <Wrapper>
        <Body>
          <div className={classes.container} style={{ marginTop: '50px' }}>
            <Grid container>
              <Grid item xs={12}>
                <div className={classes.titleContainer}>
                  <span className={classes.titleVerify}>
                    รหัสยืนยันถูกส่งไปยัง {_.get(auth, 'mobile', '')}
                  </span>
                </div>
              </Grid>
              <Grid
                container
                style={{
                  margin: 'auto',
                  marginTop: '20px',
                  marginBottom: '8px',
                  width: '230px',
                }}
                spacing={1}
              >
                <Grid item xs={2}>
                  <InputBase
                    type="number"
                    inputRef={element => {
                      this.input1 = element
                    }}
                    onKeyDown={e => {
                      if (e.keyCode === 8) {
                        this.setState({
                          isError: false,
                        })
                        // donothing
                      }
                    }}
                    onChange={event => {
                      if (event.target.value.length > 0) {
                        this.input2.focus()
                      } else {
                        // donothing
                      }
                      if (_.get(event, 'target.value.length', 0) <= 1) {
                        this.setState({
                          firstInput: event.target.value,
                        })
                      }
                      this.setState({
                        isError: false,
                      })
                    }}
                    value={firstInput}
                    className={
                      !!firstInput
                        ? classes.digitFieldActive
                        : classes.digitField
                    }
                    inputProps={{
                      maxLength: '1',
                      style: { textAlign: 'center' },
                    }}
                  />
                </Grid>
                <Grid item xs={2}>
                  <InputBase
                    type="number"
                    inputRef={element => {
                      this.input2 = element
                    }}
                    onKeyDown={e => {
                      if (e.keyCode === 8) {
                        if (
                          secondInput.length === 0 &&
                          firstInput.length !== 0
                        ) {
                          this.input1.focus()
                          this.setState({
                            firstInput: '',
                            isError: false,
                          })
                        }
                      }
                    }}
                    onChange={event => {
                      if (event.target.value.length > 0) {
                        this.input3.focus()
                      } else {
                        this.input1.focus()
                      }
                      if (_.get(event, 'target.value.length', 0) <= 1) {
                        this.setState({
                          secondInput: event.target.value,
                        })
                      }
                      this.setState({
                        isError: false,
                      })
                    }}
                    value={secondInput}
                    className={
                      !!secondInput
                        ? classes.digitFieldActive
                        : classes.digitField
                    }
                    inputProps={{
                      maxLength: '1',
                      style: { textAlign: 'center' },
                    }}
                  />
                </Grid>
                <Grid item xs={2}>
                  <InputBase
                    type="number"
                    inputRef={element => {
                      this.input3 = element
                    }}
                    onKeyDown={e => {
                      if (e.keyCode === 8) {
                        if (
                          thirdInput.length === 0 &&
                          secondInput.length !== 0
                        ) {
                          this.input2.focus()
                          this.setState({
                            secondInput: '',
                            isError: false,
                          })
                        }
                      }
                    }}
                    onChange={event => {
                      if (event.target.value.length > 0) {
                        this.input4.focus()
                      } else {
                        this.input2.focus()
                      }
                      if (_.get(event, 'target.value.length', 0) <= 1) {
                        this.setState({
                          thirdInput: event.target.value,
                        })
                      }
                      this.setState({
                        isError: false,
                      })
                    }}
                    value={thirdInput}
                    className={
                      !!thirdInput
                        ? classes.digitFieldActive
                        : classes.digitField
                    }
                    inputProps={{
                      maxLength: '1',
                      style: { textAlign: 'center' },
                    }}
                  />
                </Grid>
                <Grid item xs={2}>
                  <InputBase
                    type="number"
                    inputRef={element => {
                      this.input4 = element
                    }}
                    onKeyDown={e => {
                      if (e.keyCode === 8) {
                        if (
                          fourthInput.length === 0 &&
                          thirdInput.length !== 0
                        ) {
                          this.input3.focus()
                          this.setState({
                            thirdInput: '',
                            isError: false,
                          })
                        }
                      }
                    }}
                    onChange={event => {
                      if (event.target.value.length > 0) {
                        this.input5.focus()
                      } else {
                        this.input3.focus()
                      }
                      if (_.get(event, 'target.value.length', 0) <= 1) {
                        this.setState({
                          fourthInput: event.target.value,
                        })
                      }
                      this.setState({
                        isError: false,
                      })
                    }}
                    value={fourthInput}
                    className={
                      !!fourthInput
                        ? classes.digitFieldActive
                        : classes.digitField
                    }
                    inputProps={{
                      maxLength: '1',
                      style: { textAlign: 'center' },
                    }}
                  />
                </Grid>
                <Grid item xs={2}>
                  <InputBase
                    type="number"
                    inputRef={element => {
                      this.input5 = element
                    }}
                    onKeyDown={e => {
                      if (e.keyCode === 8) {
                        if (
                          fifthInput.length === 0 &&
                          fourthInput.length !== 0
                        ) {
                          this.input4.focus()
                          this.setState({
                            fourthInput: '',
                            isError: false,
                          })
                        }
                      }
                    }}
                    onChange={event => {
                      if (event.target.value.length > 0) {
                        this.input6.focus()
                      } else {
                        this.input4.focus()
                      }
                      if (_.get(event, 'target.value.length', 0) <= 1) {
                        this.setState({
                          fifthInput: event.target.value,
                        })
                      }
                      this.setState({
                        isError: false,
                      })
                    }}
                    value={fifthInput}
                    className={
                      !!fifthInput
                        ? classes.digitFieldActive
                        : classes.digitField
                    }
                    inputProps={{
                      maxLength: '1',
                      style: { textAlign: 'center' },
                    }}
                  />
                </Grid>
                <Grid item xs={2}>
                  <InputBase
                    type="number"
                    inputRef={element => {
                      this.input6 = element
                    }}
                    onKeyDown={e => {
                      if (e.keyCode === 8) {
                        if (
                          sixthInput.length === 0 &&
                          fifthInput.length !== 0
                        ) {
                          this.input5.focus()
                          this.setState({
                            fifthInput: '',
                            isError: false,
                          })
                        }
                      }
                    }}
                    onChange={event => {
                      if (_.get(event, 'target.value.length', 0) > 0) {
                        // donothing
                      } else {
                        this.input5.focus()
                      }
                      if (_.get(event, 'target.value.length', 0) <= 1) {
                        this.setState({
                          sixthInput: event.target.value,
                        })
                      }
                      this.setState({
                        isError: false,
                      })
                    }}
                    value={sixthInput}
                    className={
                      !!sixthInput
                        ? classes.digitFieldActive
                        : classes.digitField
                    }
                    inputProps={{
                      maxLength: '1',
                      style: { textAlign: 'center' },
                    }}
                  />
                </Grid>
              </Grid>
              <Grid item xs={12} style={{ textAlign: 'center' }}>
                <p className={classes.refCode}>
                  รหัสอ้างอิง : {_.get(userInput, 'OTPRef', '')}
                </p>
                {isError && (
                  <p className={classes.error}>รหัสยืนยันไม่ถูกต้อง</p>
                )}
                <button className={classes.resend} onClick={this.resend}>
                  ส่งอีกครั้ง
                </button>
              </Grid>
            </Grid>
          </div>
          <Modal
            styles={{ outline: 0 }}
            open={isTruePaymentError}
            onClose={() => {
              this.setState({ isTruePaymentError: false })
              this.backButton()
            }}
          >
            <div className={classes.modalContainer}>
              <IconButton
                className={classes.modalClose}
                onClick={() => {
                  this.setState({ isTruePaymentError: false })
                  this.backButton()
                }}
              >
                <Icon style={{ fontSize: '18px', color: '#4A4A4A' }}>
                  close
                </Icon>
              </IconButton>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  textAlign: 'center',
                  marginTop: '16px',
                }}
              >
                <img
                  alt="error_image"
                  src={ErrorBuy}
                  style={{ width: '100px', height: '100px' }}
                />
              </div>
              <p
                style={{
                  ...fontDefault,
                  fontWeight: 'bold',
                  fontSize: '18px',
                  textAlign: 'center',
                  marginLeft: '15px',
                  marginRight: '15px',
                  color: '#0e162c',
                }}
              >
                ไม่สามารถทำรายการได้
              </p>
              <p
                style={{
                  ...fontDefault,

                  marginLeft: '15px',
                  marginRight: '15px',
                  fontSize: '16px',
                  color: '#999999',
                }}
              >
                เนื่องจากระบบไม่สามารถตัดเงินได้ กรุณาตรวจสอบวอลเล็ท
                หรือทำรายการใหม่อีกครั้ง
              </p>

              <SubmitButton
                onClick={() => {
                  this.setState({ isTruePaymentError: false })
                  this.backButton()
                }}
              >
                ทำรายการอีกครั้ง
              </SubmitButton>
            </div>
          </Modal>
          <Modal styles={{ outline: 0 }} open={isLoading}>
            <Loading />
          </Modal>
        </Body>
        <Footer>
          <SubmitButton onClick={this.goToNextPage}>ตกลง</SubmitButton>
        </Footer>
        <Header>
          <TopBar arrowLeft={this.backButton}>
            <Typography align="center" className={classes.textTopBar}>
              กรอกรหัสยืนยัน
            </Typography>
          </TopBar>
        </Header>
      </Wrapper>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    userInput: _.get(state, 'motor.userInput', {}),
    auth: _.get(state, 'auth', {}),
    orderId: _.get(state, 'motor.userInput.orderId', ''),
    currentProduct: _.get(state, 'motor.userInput.currentProduct', ''),
    // birthData: _.get(state, 'motor.userInput.birthdate', ''),
    address: _.get(state, 'motor.userInput.address', ''),
    email: _.get(state, 'motor.userInput.email', ''),
    ID: _.get(state, 'motor.userInput.ID', ''),
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    setUserInput: data => {
      dispatch({
        type: 'USER_INPUT',
        data,
      })
    },
    showError: message => {
      dispatch({
        type: 'ME',
        data: {
          isShowError: true,
          errorMessage: message,
        },
      })
    },
  }
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(VerifyOTP))
